import React from 'react'

const Chat = () => {
  return <div data-cy="chat-section">Chat</div>
}

export default Chat
